var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2426 7.9212C18.5858 10.2643 18.5858 14.0633 16.2426 16.4065M7.75736 16.4064C5.41421 14.0633 5.41421 10.2643 7.75736 7.92117M4.92893 19.2349C1.02369 15.3297 1.02369 8.99802 4.92893 5.09277M19.0711 5.09282C22.9763 8.99806 22.9763 15.3297 19.0711 19.235M14 12.1638C14 13.2684 13.1046 14.1638 12 14.1638C10.8954 14.1638 10 13.2684 10 12.1638C10 11.0593 10.8954 10.1638 12 10.1638C13.1046 10.1638 14 11.0593 14 12.1638Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveIcon);
export default __webpack_public_path__ + "static/media/LiveIcon.57bd558658604e54429ee3d31214834a.svg";
export { ForwardRef as ReactComponent };